/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
// External deps
import { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { Formik } from 'formik';

// Internal deps
import { getMonthlyUbicationDetail } from '../../../../adapters/monthlyRequestService/monthlyRequestService';
import { validationSchema } from '../ModalAddLocation/ModalAddLocation';
import useToast from '../../../../hooks/useToast';
import AccountAssignmentObject from '../../../AccountAssignmentObject/AccountAssignmentObject';
import useRequestDetailPermissions from '../../../../hooks/useRequestDetailPermissions';

const MonthlyImputationObject = ({
  data,
  form,
  setLoading,
  canAddWellToImputationObject,
  canEditImputationObject,
  isOyM,
  fromPteAuthorization,
  setHasError,
  setDisabledActions,
  idSolicitud,
  disabledDeleteWell
}) => {
  const { id: idSolicitudData, tipoUbicacionEnum: tipoUbicacionEnumId } = data;
  const id = idSolicitud || idSolicitudData;
  const ubicationId = data?.ubicationId ?? id;

  const { setNewToast } = useToast();
  const {
    permissions: { typeAndObjectImputation }
  } = useRequestDetailPermissions({ notifyTo: 3, isASDS: true, isOyM: false });

  const initialValues = {
    imputationObject: {
      wells: [],
      wellsCopy: []
    },
    ubication: {
      ubicationType: data?.tipoUbicacionEnum,
      id: data?.idLocacion
    },
    uunn: {
      id: data?.idUnidadNegocio
    }
  };

  const getUbicationDetail = () => {
    setLoading(true);
    getMonthlyUbicationDetail({ id: ubicationId, isOyM })
      .then((res) => {
        const wells = {
          editaPozosLocacion: res.imputationObject?.editaPozosLocacion,
          esSoloAprobador: res.imputationObject?.esSoloAprobador,
          wells: res.imputationObject?.wells,
          copyWells: res.imputationObject?.wells
        };

        form.current.setFieldValue('imputationObject', wells);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
      });
  };

  useEffect(() => {
    if (id) {
      getUbicationDetail();
    }
  }, [id]);

  return (
    <Formik initialValues={initialValues} innerRef={form} validationSchema={validationSchema}>
      {({ values }) => (
        <>
          <AccountAssignmentObject
            bussinesUnitId={values.uunn?.id}
            disabledAddWell={!canAddWellToImputationObject}
            disabledDeleteWell={disabledDeleteWell}
            disabledImputationForm={!canEditImputationObject}
            formRef={form}
            fromPteAuthorization={fromPteAuthorization}
            imputationObjectDefault={!typeAndObjectImputation?.editObjectImputation}
            locationId={values.ubication?.id}
            monthlyImputationObject
            setDisabledActions={setDisabledActions}
            setHasError={setHasError}
            showDetailWell
            typeOfEventId={values?.imputationObject?.wells?.[0]?.event?.id}
            ubicationType={{
              id: tipoUbicacionEnumId
            }}
          />
        </>
      )}
    </Formik>
  );
};

MonthlyImputationObject.propTypes = {
  canAddWellToImputationObject: PropTypes.bool.isRequired,
  canEditImputationObject: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    tipoUbicacionEnum: PropTypes.number,
    idUnidadNegocio: PropTypes.number,
    idLocacion: PropTypes.number,
    ubicationId: PropTypes.number
  }).isRequired,
  idSolicitud: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  form: PropTypes.objectOf(PropTypes.shape).isRequired,
  setLoading: PropTypes.func.isRequired,
  isOyM: PropTypes.bool.isRequired,
  fromPteAuthorization: PropTypes.bool,
  setHasError: PropTypes.func,
  setDisabledActions: PropTypes.func,
  disabledDeleteWell: PropTypes.bool
};

MonthlyImputationObject.defaultProps = {
  fromPteAuthorization: false,
  setHasError: () => {},
  setDisabledActions: () => {},
  idSolicitud: null,
  disabledDeleteWell: false
};

export default MonthlyImputationObject;
